module.exports = __webpack_public_path__ + "static/media/icon-picture.48e4ef30.svg";